import { useCallback } from "react";
import { useAuth } from "../features/auth/hooks/useAuth";
import { postCandidature, PostCandidaturePayload } from "../pages/Candidature/CandidatureService";
import { useToast } from "@chakra-ui/react";

export const useCandidature = () => {
    const { userInfo, getFullName } = useAuth();
    const toast = useToast();

    const postulerMission = useCallback(
        async (missionId: string, cvFile: File): Promise<boolean> => {
            const consultantId = userInfo.sub;
            const nom = getFullName();       // ← on récupère le nom
            const status = "PENDING";

            // Vérification de la taille du fichier (50 Mo max)
            const maxSize = 50 * 1024 * 1024;
            if (cvFile.size > maxSize) {
                toast({
                    title: "Fichier trop volumineux",
                    description: "Le fichier ne doit pas dépasser 50 Mo",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
                return false;
            }

            // Conversion du CV en base64
            const base64String = await new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(cvFile);
                reader.onload = () => {
                    const result = reader.result as string;
                    resolve(result.split(",")[1]);
                };
                reader.onerror = () => reject(new Error("Erreur lors de la lecture du fichier CV"));
            });

            // Construction du payload
            const payload: PostCandidaturePayload = {
                consultantId,
                missionId,
                nom,                        // ← Ajouté
                status,
                cvBase64: base64String,
            };

            try {
                const response = await postCandidature(payload);
                if (response.status === 201 || response.status === 200) {
                    toast({
                        title: "Candidature envoyée",
                        description: "Votre candidature a été soumise avec succès",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                    return true;
                }
                return false;
            } catch (error) {
                console.error("Erreur lors de la candidature :", error);
                toast({
                    title: "Erreur",
                    description: "Impossible de soumettre la candidature",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
                return false;
            }
        },
        [userInfo.sub, getFullName, toast]
    );

    return { postulerMission };
};
